// Steps factory for the DisplayNew tour. Receives the i18n `t` function and
// returns an array of step objects. body accepts strings or React nodes.
// Steps whose target isn't present in the DOM are skipped automatically.

const getDisplayNewSteps = (t) => [
	{
		target: '.dn-rail',
		title: t('tour.displayNew.rail.title'),
		body: t('tour.displayNew.rail.body'),
	},
	{
		target: '#dn-info',
		title: t('tour.displayNew.info.title'),
		body: t('tour.displayNew.info.body'),
	},
	{
		target: '.dn-recon-toolbar',
		title: t('tour.displayNew.toolbar.title'),
		body: t('tour.displayNew.toolbar.body'),
	},
	{
		target: '.dn-recon-history',
		title: t('tour.displayNew.history.title'),
		body: t('tour.displayNew.history.body'),
	},
	{
		target: '.dn-picbtns',
		title: t('tour.displayNew.picbtns.title'),
		body: t('tour.displayNew.picbtns.body'),
	},
	{
		target: '.dn-recon-side',
		title: t('tour.displayNew.taglist.title'),
		body: t('tour.displayNew.taglist.body'),
	},
	{
		target: '.dn-recon-caption',
		title: t('tour.displayNew.caption.title'),
		body: t('tour.displayNew.caption.body'),
	},
	{
		target: '.dn-recon-summary',
		title: t('tour.displayNew.summary.title'),
		body: t('tour.displayNew.summary.body'),
	},
	{
		target: '.dn-chart',
		title: t('tour.displayNew.chart.title'),
		body: t('tour.displayNew.chart.body'),
	},
];

export default getDisplayNewSteps;
